module.exports = __webpack_public_path__ + "static/media/rpx.36ca49a4.png";